// import VersionManagement from '../views/systemManagement/versionManagement'
import ApplicationManagement from '../views/systemManagement/applicationManagement'
import IpConfig from '../views/systemManagement/ipConfig'
import SystemConfig from '../views/systemManagement/systemConfig'
import Main from '../views/main'
const SystemRouter = {
  path: '/version-management',
  component: Main,
  title: '系统管理',
  icon: 'el-icon-s-tools',
  meta: { keepAlive: true },
  children: [
    // {
    //   path: '/version-management',
    //   component: VersionManagement,
    //   name: 'versionManagement',
    //   title: '版本管理',
    //   meta: { title: '版本管理' ,keepAlive:true}
    // },
    {
      path: '/application-management',
      component: ApplicationManagement,
      name: 'applicationManagement',
      title: '应用管理',
      meta: { title: '应用管理' ,keepAlive:true}
    },
    {
      path: '/ipConfig',
      component: IpConfig,
      name: 'ipConfig',
      title: 'ip白名单配置',
      meta: { title: 'ip白名单配置', keepAlive: true }
    },
    {
      path: '/systemConfig',
      component: SystemConfig,
      name: 'systemConfig',
      title: '系统配置',
      meta: { title: '系统配置', keepAlive: true }
    },
  ]
}
export default SystemRouter
